import React from "react";
import _ from "lodash";

import ImagePreventRightClick from "core/ImagePreventRightClick";

export const numberOfMockItems = 50;
export const mockDataList = new Array(numberOfMockItems)
    .fill("")
    .map((data, index) => {
        const width = _.random(100, 1000);
        const height = _.random(100, 1000);

        return {
            title: `Title ${index}`,
            imageSrc: `https://placeimg.com/${width}/${height}/animals`,
            ratio: width / height
        };
    });

export const mockItemRatios = mockDataList.map(item => item.ratio);

export const mockGridContent = mockDataList.map((data, index) => (
    <ImagePreventRightClick
        imageSrc={data.imageSrc}
        srText="image-description"
        key={index}
    />
));
